import Keycloak from "keycloak-js";

export const keycloak = new Keycloak({
  realm: "Pulse",
  url: import.meta.env.VITE_APP_AUTH_CLIENT_BASE_URL,
  clientId: "pulse-fe",
});
